export const DEMO_MODE_INFO_MESSAGE = 'This action is not supported in demo mode';
